import React, {useState} from 'react';
import {RecommendationComment} from "../../../services/models/recommendation_comment";
import styles from "./recomDetail.module.css"
import {Administrator} from "../../../services/models/administrator";
import {SubUser} from "../../../services/models/sub_user";
import userIcon from "../../../assets/img/userIcon.svg"
import stylesInputs from "../../../assets/styles/inputs.module.css";
import stylesButtons from "../../../assets/styles/buttons.module.css";
import {useCreateRecommComment} from "../../../hooks/useQuery/useCreateRecommComment";
import {useParams} from "react-router-dom";

interface CommentBlockProps {
    comments?: RecommendationComment[];
    user?: SubUser | Administrator;
}

export const CommentBlock: React.FC<CommentBlockProps> = ({user, comments}) => {
    const {recommendationId} = useParams();
    const itsMe = (comment: RecommendationComment) => {
        return user?.id === comment.owner
    }
    const [newComment, setNewComment] = useState("")
    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewComment(e.target.value);
    }

    const addCommentMutation = useCreateRecommComment()
    const handleAddComment = async () => {
        await addCommentMutation.mutateAsync(
            {
                text: newComment,
                recommendation: recommendationId
            },
        )
        setNewComment("")
    }
    return (
        <div className={styles.commentsWrapper}>
            {(comments && comments.length > 0) ? comments.map((comment: RecommendationComment) => (
                <div key={comment.id}
                     className={`${styles.commentWrapper} ${itsMe(comment) ? styles.myComment : styles.anotherComment}`}>

                    {itsMe(comment) && (
                        <div
                            className={`${styles.commentTextBlock}`}>
                            <p className={styles.text}>{comment.text}</p>
                            <p className={styles.date}>{comment.created_at}</p>
                        </div>
                    )}
                    {!itsMe(comment) && (

                        <div className={styles.anotherCommentWrapper}>
                            <div className={styles.photo}>
                                <img src={userIcon} alt="Аватар"/>
                            </div>
                            <div>
                                <p className={styles.userName}>{comment.full_name}</p>
                                <div
                                    className={`${styles.commentTextBlock}`}>
                                    <p className={styles.text}>{comment.text}</p>
                                    <p className={styles.date}>{comment.created_at}</p>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            )) : (
                <div className={styles.notCommentsBlock}>Нет сообщений</div>
            )}
            <div className={styles.commentAddWrapper}>
                <div className={styles.inputWrapper}>
                    <input
                        type="text"
                        className={`${styles.inputField} ${stylesInputs.mainInput}`}
                        value={newComment}
                        placeholder={"Введите сообщение"}
                        onChange={handleChangeInput}
                    />
                    {newComment && (
                        <button
                            type="button"
                            className={styles.clear}
                            onClick={() => setNewComment("")}
                            tabIndex={-1}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                 fill="none">
                                <path
                                    d="M8.00065 15.1663C4.04732 15.1663 0.833984 11.953 0.833984 7.99967C0.833984 4.04634 4.04732 0.833008 8.00065 0.833008C11.954 0.833008 15.1673 4.04634 15.1673 7.99967C15.1673 11.953 11.954 15.1663 8.00065 15.1663ZM8.00065 1.83301C4.60065 1.83301 1.83398 4.59967 1.83398 7.99967C1.83398 11.3997 4.60065 14.1663 8.00065 14.1663C11.4007 14.1663 14.1673 11.3997 14.1673 7.99967C14.1673 4.59967 11.4007 1.83301 8.00065 1.83301Z"
                                    fill="#AFAFAF"/>
                                <path
                                    d="M6.11398 10.3863C5.98732 10.3863 5.86065 10.3397 5.76065 10.2397C5.56732 10.0463 5.56732 9.72634 5.76065 9.53301L9.53399 5.75968C9.72732 5.56634 10.0473 5.56634 10.2407 5.75968C10.434 5.95301 10.434 6.27301 10.2407 6.46634L6.46732 10.2397C6.37398 10.3397 6.24065 10.3863 6.11398 10.3863Z"
                                    fill="#AFAFAF"/>
                                <path
                                    d="M9.88732 10.3863C9.76065 10.3863 9.63399 10.3397 9.53399 10.2397L5.76065 6.46634C5.56732 6.27301 5.56732 5.95301 5.76065 5.75968C5.95399 5.56634 6.27398 5.56634 6.46732 5.75968L10.2407 9.53301C10.434 9.72634 10.434 10.0463 10.2407 10.2397C10.1407 10.3397 10.014 10.3863 9.88732 10.3863Z"
                                    fill="#AFAFAF"/>
                            </svg>
                        </button>
                    )}
                </div>
                <button
                    className={`${stylesButtons.mainButton} ${stylesButtons.iconButton} ${stylesButtons.sendButtonRight} ${styles.sendButton}`}
                    disabled={newComment.trim() === ""}
                    onClick={handleAddComment}>
                    Отправить
                </button>
            </div>
        </div>
    )
};